/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react'

interface IProps {
	switchAmount: number
	titles: string[]
	defaultValue: number | undefined
	setRadio: React.Dispatch<React.SetStateAction<number>>
	setValue: React.Dispatch<React.SetStateAction<any>>
	onChange?: () => void
}
const alings = ['start', 'center', 'end']

export default function RadioGroupComponent(props: IProps): React.ReactElement {
	const posts = []
	const [selected, setSelected] = useState(props.defaultValue)

	for (let i = 0; i < props.switchAmount; i++) {
		posts.push({ title: '', content: '' })
	}

	useEffect(() => {
		setSelected(props.defaultValue)
	}, [props.defaultValue])
	return (
		<div className="content-radio">
			<div className="content-titles">
				{props.titles.map((t, index) => (
					<div
						className="titles"
						key={t}
						style={{
							textAlign: alings[index] as any,
						}}
					>
						{' '}
						{t}{' '}
					</div>
				))}
			</div>

			<div className="inputs">
				{posts.map((post, index) => (
					<div key={`radio_${post.content + index}`}>
						<input
							type="radio"
							title={post.title}
							className="input-radio"
							value={index + 1}
							name="myGroup"
							onChange={() => {
								props.setRadio(index + 1)
								setSelected(index + 1)
							}}
							checked={selected === index + 1}
						/>
						<label style={{ fontFamily: 'mont-regular' }}>{index + 1}</label>
					</div>
				))}
			</div>
		</div>
	)
}
